import React, { useCallback, useState } from 'react';
import { useTranslate } from '@im/react-localization';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { isEmpty } from '../../../components/JsonViewer/utils/common.utils';
import { useBidDetails } from '../hooks/use-biddetails';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import { useSearchParams } from 'react-router-dom';
import JsonViewerDialog from 'src/components/JsonViewer/JsonViewerDialog';

export default function BidJSON(
  props: Readonly<{ disable: boolean; parserHeaderID: string | undefined }>
) {
  const { disable, parserHeaderID } = props;
  const [searchParams] = useSearchParams();
  const countryCode = searchParams.get('countryCode');
  const [open, setOpen] = useState(false);

  const translate = useTranslate();

  const { data, isError, isLoading } = useBidDetails(
    {
      countryCode: countryCode ?? '',
      headerId: parserHeaderID ?? '',
    },
    open && !isEmpty(parserHeaderID)
  );

  const handleOpen = () => setOpen(true);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Box>
      <Button
        disabled={disable}
        onClick={() => handleOpen()}
        startIcon={<DeveloperModeIcon />}
      >
        {translate('BidLifeCycle.ViewJSON')}
      </Button>
      <JsonViewerDialog
        handleClose={handleClose}
        heading={translate('BidLifeCycle.BidDetailsPopupHeader')}
        isError={isError}
        isLoading={isLoading}
        json={data}
        open={open}
      />
    </Box>
  );
}
